/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ApplicationStateFactory, FormState } from '@gh/common-shared';
import { bind } from 'lodash';
import { BuilderUserContext } from '../../user/builder-user-context';
import { BuilderApplicationState } from './builder-application-state';

@Injectable()
export class BuilderApplicationStateFactory extends ApplicationStateFactory {

  constructor(private userContext: BuilderUserContext) {
    super();
  }

  createByForm(state: FormState<any>): BuilderApplicationState {
    const { applicationView, userType, isSwitched, hasPermission, hasSystemRole } = this.userContext;

    return <any>{
      applicationView,
      userType,
      isSwitched: bind(isSwitched, this.userContext),
      hasPermission: bind(hasPermission, this.userContext),
      hasSystemRole: bind(hasSystemRole, this.userContext),
      currentForm: state,
    };
  }
}
